export default __webpack_public_path__ + "static/media/project5.a0c3841f.png";